var _rect, _line, _line2, _rect2, _path, _path2, _rect3, _line3, _line4, _rect4, _path3, _path4, _mask, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelmert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.497954,
    y: 32.9472,
    width: 21.958,
    height: 12.1102,
    transform: "rotate(-6.80309 0.497954 32.9472)",
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.62624,
    y1: 40.7204,
    x2: 23.5618,
    y2: 38.1036,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.12184,
    y1: 36.4919,
    x2: 23.0574,
    y2: 33.8751,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.8979,
    y: 32.0644,
    width: 7.05317,
    height: 12.1102,
    transform: "rotate(-6.80309 7.8979 32.0644)",
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3133 39.6557C13.3871 39.6557 23.1948 20.0025 23.1948 13.5974C23.1948 7.19233 18.0025 2 11.5974 2C5.19233 2 0 7.19233 0 13.5974C0 20.0025 11.2394 39.6557 12.3133 39.6557Z",
    fill: "#0064BA",
    className: "border"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4108 10.0967C19.8752 12.8466 19 16.0155 19 19.3888C19 20.4005 19.1704 21.613 19.48 22.9785C16.7464 29.9193 12.7162 37.548 12.0761 37.548C11.0932 37.548 0.805222 19.5585 0.805222 13.6957C0.805222 7.83284 5.55798 3.08008 11.4208 3.08008C16.0203 3.08008 19.9366 6.00524 21.4108 10.0967ZM16 13.5C16 15.9853 13.9853 18 11.5 18C9.01473 18 7.00002 15.9853 7.00002 13.5C7.00002 11.0147 9.01473 9 11.5 9C13.9853 9 16 11.0147 16 13.5Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3327,
    y: 52.3249,
    width: 40.0099,
    height: 22.3042,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 66.972,
    x2: 60.2183,
    y2: 66.972,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 20.9571,
    y1: 59.3157,
    x2: 60.6753,
    y2: 59.3157,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7316,
    y: 52.3249,
    width: 13.2121,
    height: 22.3042,
    stroke: "white",
    strokeWidth: 0.665393,
    className: "grid-line"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.358 65.7684C42.3951 65.7684 61 31.4426 61 20.2557C61 9.06877 51.1503 0 39 0C26.8498 0 17 9.06877 17 20.2557C17 31.4426 38.321 65.7684 40.358 65.7684Z",
    fill: "#0064BA",
    className: "border"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2643 63.2737C42.0315 63.2737 58.1722 30.9298 58.1722 20.3888C58.1722 9.84788 49.6271 1.30273 39.0861 1.30273C28.5452 1.30273 20 9.84788 20 20.3888C20 30.9298 38.497 63.2737 40.2643 63.2737ZM39 27C42.866 27 46 23.866 46 20C46 16.134 42.866 13 39 13C35.134 13 32 16.134 32 20C32 23.866 35.134 27 39 27Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_43_18092",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1323 61.4307L32.6718 58.7634L39.858 65.1064L30.7717 68.1583L31.2732 65.6787C29.6312 65.4679 27.9984 65.0086 26.4068 64.3063C23.6643 63.0961 21.0977 61.188 18.8535 58.6909C16.6093 56.1938 14.7315 53.1566 13.3272 49.7528C11.9229 46.349 11.0198 42.6451 10.6692 38.8528L13.894 38.5547C14.192 41.7782 14.9597 44.9265 16.1533 47.8197C17.3469 50.713 18.9431 53.2946 20.8507 55.4171C22.7582 57.5396 24.9398 59.1615 27.271 60.1902C28.8579 60.8904 30.493 61.3065 32.1323 61.4307Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1323 61.4307L32.6718 58.7634L39.858 65.1064L30.7717 68.1583L31.2732 65.6787C29.6312 65.4679 27.9984 65.0086 26.4068 64.3063C23.6643 63.0961 21.0977 61.188 18.8535 58.6909C16.6093 56.1938 14.7315 53.1566 13.3272 49.7528C11.9229 46.349 11.0198 42.6451 10.6692 38.8528L13.894 38.5547C14.192 41.7782 14.9597 44.9265 16.1533 47.8197C17.3469 50.713 18.9431 53.2946 20.8507 55.4171C22.7582 57.5396 24.9398 59.1615 27.271 60.1902C28.8579 60.8904 30.493 61.3065 32.1323 61.4307Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1323 61.4307L32.0757 62.1786L32.7361 62.2286L32.8675 61.5794L32.1323 61.4307ZM32.6718 58.7634L33.1681 58.2011L32.1942 57.3415L31.9367 58.6147L32.6718 58.7634ZM39.858 65.1064L40.0968 65.8174L41.3282 65.4038L40.3543 64.5441L39.858 65.1064ZM30.7717 68.1583L30.0366 68.0097L29.7791 69.2829L31.0105 68.8693L30.7717 68.1583ZM31.2732 65.6787L32.0083 65.8274L32.1681 65.0374L31.3687 64.9348L31.2732 65.6787ZM26.4068 64.3063L26.7096 63.6201L26.7096 63.6201L26.4068 64.3063ZM18.8535 58.6909L18.2957 59.1922L18.2957 59.1922L18.8535 58.6909ZM13.3272 49.7528L12.6339 50.0388L13.3272 49.7528ZM10.6692 38.8528L10.6002 38.1059L9.85339 38.175L9.92242 38.9218L10.6692 38.8528ZM13.894 38.5547L14.6409 38.4857L14.5718 37.7388L13.825 37.8079L13.894 38.5547ZM16.1533 47.8197L16.8466 47.5337L16.8466 47.5337L16.1533 47.8197ZM20.8507 55.4171L21.4085 54.9158L21.4085 54.9158L20.8507 55.4171ZM27.271 60.1902L26.9682 60.8763L26.9682 60.8763L27.271 60.1902ZM32.8675 61.5794L33.4069 58.9121L31.9367 58.6147L31.3972 61.282L32.8675 61.5794ZM32.1755 59.3257L39.3617 65.6687L40.3543 64.5441L33.1681 58.2011L32.1755 59.3257ZM39.6192 64.3954L30.5329 67.4474L31.0105 68.8693L40.0968 65.8174L39.6192 64.3954ZM31.5068 68.307L32.0083 65.8274L30.5381 65.53L30.0366 68.0097L31.5068 68.307ZM31.3687 64.9348C29.8013 64.7336 28.2381 64.2946 26.7096 63.6201L26.104 64.9924C27.7587 65.7226 29.4612 66.2022 31.1777 66.4226L31.3687 64.9348ZM26.7096 63.6201C24.0753 62.4576 21.5931 60.6172 19.4113 58.1895L18.2957 59.1922C20.6023 61.7588 23.2533 63.7345 26.104 64.9924L26.7096 63.6201ZM19.4113 58.1895C17.2295 55.7618 15.3953 52.7993 14.0205 49.4668L12.6339 50.0388C14.0676 53.514 15.9891 56.6257 18.2957 59.1922L19.4113 58.1895ZM14.0205 49.4668C12.6458 46.1345 11.7599 42.5041 11.4161 38.7837L9.92242 38.9218C10.2796 42.7862 11.2001 46.5634 12.6339 50.0388L14.0205 49.4668ZM10.7383 39.5996L13.9631 39.3015L13.825 37.8079L10.6002 38.1059L10.7383 39.5996ZM13.1472 38.6237C13.4518 41.9192 14.2368 45.1409 15.46 48.1057L16.8466 47.5337C15.6825 44.712 14.9321 41.6372 14.6409 38.4857L13.1472 38.6237ZM15.46 48.1057C16.683 51.0703 18.3229 53.7265 20.2928 55.9184L21.4085 54.9158C19.5633 52.8626 18.0108 50.3556 16.8466 47.5337L15.46 48.1057ZM20.2928 55.9184C22.2628 58.1104 24.5289 59.7999 26.9682 60.8763L27.5737 59.504C25.3508 58.5231 23.2536 56.9688 21.4085 54.9158L20.2928 55.9184ZM26.9682 60.8763C28.6293 61.6093 30.3473 62.0476 32.0757 62.1786L32.189 60.6829C30.6387 60.5654 29.0866 60.1716 27.5737 59.504L26.9682 60.8763Z",
    fill: "#0064BA",
    mask: "url(#path-13-inside-1_43_18092)",
    className: "border"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmert);
export default __webpack_public_path__ + "static/media/helmert.c3dc7aad76615e9a7fa375e2a7ecd35e.svg";
export { ForwardRef as ReactComponent };